import { render, staticRenderFns } from "./TorqueViz.vue?vue&type=template&id=13799d2e&scoped=true"
import script from "./TorqueViz.vue?vue&type=script&lang=js"
export * from "./TorqueViz.vue?vue&type=script&lang=js"
import style0 from "./TorqueViz.vue?vue&type=style&index=0&id=13799d2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13799d2e",
  null
  
)

export default component.exports